module.exports = __webpack_public_path__ + "static/media/1to1-bi-directional.4809a921.png";